const INITIAL_STATE = {
  0: {
    id: 0,
    type: 'selectAllBox',
  },
  1: {
    id: 1,
    type: 'sortable',
    text: 'Category Description',
    key: 'categoryDescription',
  },
  3: {
    id: 2,
    type: 'sortable',
    text: 'Category Code',
    key: 'categoryCode',
  },
  4: {
    id: 3,
    type: 'sortable',
    text: 'CPD Module Title',
    key: 'cpdCourse',
  },

};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case 'ToggleSortList':
      return {
        ...state,
      };

    default:
  }
  return { ...state };
};
